import { render } from "./NcrmRecordEditDialog.vue?vue&type=template&id=82d484de"
import script from "./NcrmRecordEditDialog.vue?vue&type=script&lang=js"
export * from "./NcrmRecordEditDialog.vue?vue&type=script&lang=js"

import "./NcrmRecordEditDialog.vue?vue&type=style&index=0&id=82d484de&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__